import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Swiftdzireonrentinnavimumbai() {



const cardData = {
  keyword: " Swift Dzire on Rent in Navi Mumbai",

headingDescription:
  "Omshree Cab provides reliable and comfortable Swift Dzire on rent in Navi Mumbai for travelers who want a smooth, efficient, and budget‑friendly ride for city travel, airport transfers, family outings, or outstation trips. The Swift Dzire is a popular sedan known for its excellent fuel efficiency, comfortable seating, compact design, and easy handling — making it ideal for solo travelers, couples, and small families. We offer flexible rental options including one‑way bookings, round trips, hourly packages, and full‑day rentals with transparent pricing and no hidden charges. All Swift Dzire vehicles in our fleet are air‑conditioned, well‑maintained, and driven by professional chauffeurs familiar with Navi Mumbai’s roads and traffic. With easy online booking, punctual pickups from anywhere in Navi Mumbai (including airport, railway stations, hotels, and residences), and 24/7 customer support, renting a Swift Dzire in Navi Mumbai becomes a smooth and stress‑free experience.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of Navi Mumbai’s largest and most scenic urban parks, featuring sprawling green lawns, landscaped gardens, walking paths, and recreational areas perfect for family picnics, morning walks, and relaxation. Visitors enjoy the peaceful environment, open spaces, and scenic surroundings. Renting a Swift Dzire makes it convenient and comfortable for visitors to reach this outdoor destination and enjoy quality time with friends and family."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a beautiful natural attraction near Kharghar, especially popular during the monsoon season when water cascades over rocky cliffs amid lush greenery. Visitors often come here for nature walks, photography, and short treks. Renting a Swift Dzire in Navi Mumbai provides an easy and comfortable way for travelers to reach this scenic spot and enjoy the refreshing environment."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is a major shopping and entertainment destination featuring international brands, eateries, cafés, and a multiplex cinema. Visitors can shop, dine, and enjoy leisure activities with family and friends. Renting a Swift Dzire makes it easy to travel comfortably to this popular mall while exploring the vibrant lifestyle and shopping scene of Navi Mumbai."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a well‑known landmark in Kharghar recognized for its unique architectural design and decorative fountains. The area around the chowk has several restaurants, cafés, and shops where visitors can spend leisure time. It’s a popular spot for evening outings and photography. Renting a Swift Dzire offers an efficient and comfortable ride to this vibrant city spot."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is one of Navi Mumbai’s most scenic roads, connecting Vashi, Nerul, and Belapur and offering views of the waterfront and skyline. Many people enjoy evening drives along this route because of the calm environment and picturesque setting. Renting a Swift Dzire provides a smooth and comfortable city drive while sightseeing along this iconic road."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic site near CBD Belapur that reflects a rich cultural past. Visitors can explore old fort walls, scenic surroundings, and learn about the area’s heritage. Renting a Swift Dzire makes it easy for visitors to reach this historical attraction and enjoy the peaceful environment."
  },
  {
    title: "ISKCON Kharghar",
    description:
      "ISKCON Kharghar is a spiritual center dedicated to Lord Krishna and offers a peaceful atmosphere for devotees and visitors. The temple hosts prayers, meditation sessions, and cultural programs. Renting a Swift Dzire provides convenient and comfortable transportation for devotees planning a visit to this spiritual destination."
  },
  {
    title: "Golf Course Kharghar",
    description:
      "The Kharghar Golf Course is a popular outdoor recreational area featuring green fields and scenic views. Visitors enjoy walking, relaxation, and leisure activities in this well‑maintained environment. Renting a Swift Dzire provides adequate space and comfort to reach this pleasant location while exploring Navi Mumbai."
  },
  {
    title: "Nerul Balaji Temple",
    description:
      "Nerul Balaji Temple is a religious site dedicated to Lord Venkateswara and is known for its traditional South Indian architectural style and peaceful setting. Devotees and tourists visit for darshan, prayers, and spiritual experiences. Renting a Swift Dzire offers a comfortable option to reach this revered temple within Navi Mumbai."
  },
  {
    title: "Sagar Vihar",
    description:
      "Sagar Vihar is a peaceful waterfront promenade in Vashi overlooking the Thane Creek, popular for evening walks, photography, and family outings. Visitors enjoy the cool breeze and scenic views, especially during sunset. Renting a Swift Dzire provides a smooth and comfortable ride to this scenic waterfront destination."
  }
],



services: [
{
name: "Swift Dzire on Rent Navi Mumbai",
description: "Swift Dzire on rent in Navi Mumbai provides comfortable and affordable sedan travel for daily city rides, airport transfers, and outstation journeys. The Maruti Swift Dzire is one of the most popular sedan cars known for smooth driving, fuel efficiency, and comfortable interiors. It is perfect for business travelers, families, and tourists visiting Navi Mumbai. Professional drivers ensure punctual pickup and safe driving across all major areas of Navi Mumbai. The vehicle offers comfortable seating for passengers with sufficient luggage space for travel. Whether it is a local trip or an intercity journey, Dzire provides reliable transportation. Customers enjoy comfortable travel with economical pricing and dependable service."
},
{
name: "Dzire Rental Navi Mumbai",
description: "Dzire rental in Navi Mumbai offers convenient sedan car transportation for local travel and outstation trips. The Swift Dzire provides smooth driving performance and comfortable seating for passengers during city and highway travel. It is ideal for airport transfers, business meetings, and family travel. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai locations. Vehicles are well maintained with clean interiors and efficient air conditioning. Travelers enjoy a comfortable and economical sedan ride for everyday transportation. The rental service provides dependable travel solutions for individuals and small families."
},
{
name: "Dzire Cab Service Navi Mumbai",
description: "Dzire cab service in Navi Mumbai provides reliable taxi transportation for daily travel and long-distance journeys. The sedan offers comfortable seating, smooth suspension, and strong AC cooling for relaxed travel. Professional drivers ensure punctual pickup and safe driving throughout the journey. It is ideal for office travel, airport transfers, and intercity trips. Passengers enjoy convenient travel with a comfortable sedan vehicle. The service is widely used by travelers looking for affordable yet comfortable transportation. Customers benefit from reliable booking support and professional drivers."
},
{
name: "Dzire Taxi Navi Mumbai",
description: "Dzire taxi in Navi Mumbai is a popular sedan taxi option for comfortable city and outstation travel. The vehicle offers comfortable seating and smooth driving performance suitable for both short and long journeys. Ideal for airport pickups, business meetings, and family trips. Professional drivers ensure timely pickup services and safe driving across Navi Mumbai. Passengers enjoy air-conditioned comfort and reliable transportation. The Dzire taxi is known for fuel efficiency and smooth ride quality. It is an economical and dependable travel option."
},
{
name: "Dzire Airport Cab Navi Mumbai",
description: "Dzire airport cab in Navi Mumbai provides reliable airport pickup and drop services for travelers. The sedan offers comfortable seating and sufficient luggage space for airport travel. Professional drivers track flight timings to ensure punctual pickups and drop-offs. Ideal for business travelers, tourists, and families traveling to or from the airport. The vehicle provides comfortable AC interiors and smooth ride quality. Passengers enjoy convenient airport transportation across Navi Mumbai. The service ensures stress-free travel to and from the airport."
},
{
name: "Dzire Outstation Cab Navi Mumbai",
description: "Dzire outstation cab in Navi Mumbai provides comfortable long-distance travel for tourists and business travelers. The sedan offers smooth highway performance and comfortable seating for extended journeys. It is ideal for travel to Pune, Nashik, Lonavala, Shirdi, and other destinations. Professional drivers ensure safe highway driving and punctual pickup services. The vehicle provides efficient AC cooling and comfortable ride quality for passengers. Families and individuals enjoy relaxed travel with dependable service. It is an economical choice for outstation journeys."
},
{
name: "Dzire One Way Cab Navi Mumbai",
description: "Dzire one way cab in Navi Mumbai provides economical intercity transportation without return charges. This service is ideal for passengers who need drop service to another city. The sedan provides comfortable seating and reliable highway driving performance. Professional drivers ensure safe driving and timely pickups across Navi Mumbai. The vehicle offers smooth ride quality for long-distance travel. Passengers enjoy affordable transportation with flexible travel options. It is perfect for airport transfers and one-way intercity travel."
},
{
name: "Dzire Round Trip Taxi Navi Mumbai",
description: "Dzire round trip taxi in Navi Mumbai provides convenient return travel for passengers planning round-trip journeys. The vehicle remains available for the entire travel duration making sightseeing and meetings easier. Comfortable seating and powerful AC ensure relaxed travel during long journeys. Professional drivers ensure safe driving and reliable service throughout the trip. Ideal for family vacations and corporate travel. Passengers enjoy flexible travel schedules and dependable transportation. The service ensures comfortable two-way travel."
},
{
name: "Cheap Dzire Rental Navi Mumbai",
description: "Cheap Dzire rental in Navi Mumbai provides budget-friendly sedan transportation without compromising comfort or safety. The Swift Dzire offers spacious seating, smooth driving, and reliable performance for city and highway travel. Professional drivers ensure safe driving and punctual pickup services. It is ideal for airport transfers, daily office travel, and outstation trips. Travelers enjoy economical fares with comfortable travel experiences. The service provides dependable transportation at affordable prices. Customers benefit from convenient and cost-effective travel."
},
{
name: "Dzire Cab Booking Navi Mumbai",
description: "Dzire cab booking in Navi Mumbai allows passengers to easily reserve comfortable sedan taxis for daily travel and outstation journeys. Customers can book vehicles through phone or online platforms with quick confirmation. The vehicle offers comfortable seating and reliable ride quality for passengers. Professional drivers ensure punctual pickups and safe driving throughout the trip. Ideal for airport transfers, office travel, and family trips. Booking is simple and convenient for travelers. Customers enjoy dependable transportation with professional service."
},
{
name: "Dzire Taxi Booking Online Navi Mumbai",
description: "Dzire taxi booking online in Navi Mumbai provides quick and convenient digital reservations for travelers. Customers can schedule rides easily through online platforms with instant booking confirmation. The sedan offers comfortable seating and smooth ride quality for city and highway travel. Ideal for airport transfers, daily commuting, and intercity journeys. Professional drivers ensure safe driving and punctual service. Online booking simplifies travel planning for passengers. Travelers enjoy hassle-free transportation with reliable service."
},
{
name: "Best Dzire Rental Navi Mumbai",
description: "Best Dzire rental in Navi Mumbai provides high-quality sedan transportation with professional service and well-maintained vehicles. The Swift Dzire offers comfortable interiors and smooth driving performance for both local and outstation travel. Professional drivers ensure punctual pickup and safe driving across Navi Mumbai. The vehicle is ideal for airport transfers, business trips, and family travel. Customers receive reliable service and comfortable travel experiences. The sedan provides economical yet premium travel comfort. Travelers enjoy dependable transportation every time."
},
{
name: "Family Dzire Cab Navi Mumbai",
description: "Family Dzire cab in Navi Mumbai provides comfortable sedan transportation for families traveling together. The vehicle offers spacious seating and smooth ride quality for family trips and outings. Ideal for airport travel, sightseeing, and weekend trips. Professional drivers ensure safe driving and punctual pickup services. Air-conditioned interiors provide comfortable travel during long journeys. Families enjoy convenient and relaxed transportation. The service provides reliable travel solutions for family passengers."
},
{
name: "Sedan Cab Dzire Navi Mumbai",
description: "Sedan cab Dzire in Navi Mumbai provides dependable sedan taxi service for comfortable city and outstation travel. The Swift Dzire offers spacious seating and smooth driving performance for passengers. Ideal for airport transfers, business travel, and daily commuting. Professional drivers ensure safe driving and timely pickups across Navi Mumbai. The vehicle provides comfortable interiors and reliable performance. Passengers enjoy economical and comfortable transportation. It is one of the most preferred sedan taxi services in Navi Mumbai."
}
],

tableData: [
["Swift Dzire on Rent Navi Mumbai","Dzire Rental Navi Mumbai"],
["Dzire Cab Service Navi Mumbai","Dzire Taxi Navi Mumbai"],
["Dzire Airport Cab Navi Mumbai","Dzire Outstation Cab Navi Mumbai"],
["Dzire One Way Cab Navi Mumbai","Dzire Round Trip Taxi Navi Mumbai"],
["Cheap Dzire Rental Navi Mumbai","Dzire Cab Booking Navi Mumbai"],
["Dzire Taxi Booking Online Navi Mumbai","Best Dzire Rental Navi Mumbai"],
["Family Dzire Cab Navi Mumbai","Sedan Cab Dzire Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Sedan Travel",
    WhyChoosedescription: "Maruti Swift Dzire is a comfortable and fuel-efficient sedan ideal for city travel, airport transfers, and outstation journeys from Navi Mumbai. The car offers smooth suspension, spacious seating, and good luggage capacity for relaxed travel."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Swift Dzire on rent in Navi Mumbai. Customers receive clear details about per-kilometer charges, driver allowance, and toll costs before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Swift Dzire rental service in Navi Mumbai operates 24 hours a day. Whether you need an early morning airport pickup or late-night travel, our sedan cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Well Maintained Vehicles",
    WhyChoosedescription: "All Swift Dzire vehicles are regularly serviced, cleaned, and sanitized to ensure passengers enjoy a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Local & Outstation Packages",
    WhyChoosedescription: "We provide flexible travel options including local Navi Mumbai travel, airport pickup and drop, and outstation cab services to destinations like Pune, Lonavala, Nashik, Shirdi, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Affordable Sedan Cab Option",
    WhyChoosedescription: "Swift Dzire is one of the most affordable sedan cab options for individuals, couples, and small families who want comfortable travel at budget-friendly prices."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "Omshree Cabs provides convenient pickup from homes, offices, hotels, railway stations, and business centers across Navi Mumbai."
  },
  {
    WhyChooseheading: "Trusted Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Swift Dzire rental in Navi Mumbai thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Swift Dzire on rent in Navi Mumbai?", answer: "Yes, Omshree Cabs provides Maruti Swift Dzire rental services in Navi Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Swift Dzire?", answer: "Swift Dzire is a 4+1 seater sedan suitable for small families, couples, and business travelers." },
  { question: "What is the per km rate for Swift Dzire in Navi Mumbai?", answer: "Swift Dzire rental rates usually start around ₹13 per km depending on the travel package and provider." },
  { question: "Can I book Swift Dzire for airport pickup?", answer: "Yes, Swift Dzire can be booked for Mumbai Airport and Navi Mumbai Airport pickup and drop services." },
  { question: "Is Swift Dzire suitable for outstation travel?", answer: "Yes, Swift Dzire is commonly used for outstation trips from Navi Mumbai to destinations like Pune, Lonavala, Nashik, and Shirdi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all Swift Dzire vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide a driver with the car?", answer: "Yes, Swift Dzire rentals include a professional driver for safe and convenient travel." },
  { question: "Can Swift Dzire be used for corporate travel?", answer: "Yes, Swift Dzire is widely used for corporate travel, airport transfers, and executive transportation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended during weekends and peak travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Mehta",
    feedback:
      "We booked a Swift Dzire from Omshree Cabs for our Navi Mumbai to Pune trip. The car was comfortable and the driver was punctual.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Very good Swift Dzire cab service in Navi Mumbai. Clean vehicle, smooth ride, and affordable pricing.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides Swift Dzire on rent in Navi Mumbai for airport transfers, one-way and round trips, outstation journeys, family rides, and corporate travel. Affordable and reliable service.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Swift Dzire on Rent",
    "Airport Transfer",
    "Outstation Cab",
    "One Way Cab",
    "Round Trip Taxi",
    "Family Cab",
    "Corporate Cab",
    "Sedan Rental",
    "Affordable Cab Rental"
  ]
};







  return (
    <div>
      
<Helmet>
  <title>Swift Dzire On Rent in Navi Mumbai | Omshree Cab</title>
  <meta
    name="description"
    content="Rent a Swift Dzire in Navi Mumbai with Omshree Cab. Available for airport transfers, one-way trips, round trips, outstation travel, family and corporate use. Affordable and reliable sedan cab service."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinnavimumbai;